import { isDSPFeatureEnabled } from "@amzn/carrierlogistics-commons/dist/utils/featureFlags/dspFeature";
import { GetAuthorizedLogisticsPartiesInput, ServiceProviderIdentifierType } from "@amzn/coral_com-amazon-carrierlogisticswebserver-model";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAuthorizedLps } from "../../actions/lp";
import { GET_AUTHORIZED_LPS_REQUEST } from "../../actions/lp/actionTypes";
import { getAuthorizedDSPsSelector } from "../../actions/lp/selectors";
export function useAuthorizedDSPs() {
    var dispatch = useDispatch();
    var authorizedDSPs = useSelector(getAuthorizedDSPsSelector);
    useEffect(function() {
        if (!isDSPFeatureEnabled()) return;
        dispatch(getAuthorizedLps.request({
            getAuthorizedLpsInput: GetAuthorizedLogisticsPartiesInput.clone({
                serviceProviderIdentifierType: ServiceProviderIdentifierType.DSP_COMPANY_ID
            })
        }, GET_AUTHORIZED_LPS_REQUEST));
    }, [
        dispatch
    ]);
    return authorizedDSPs;
}

//# sourceMappingURL=useAuthorizedDSPs.js.map